// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__abVwY","content":"styles_content__11a_Q","tableWrap":"styles_tableWrap__2HsT_"};